<template>
  <el-dialog
    class="sh-dialog"
    :width="$attrs.width || '1000px'"
    :visible.sync="visible"
    v-bind="$attrs"
    v-on="$listeners"
    :before-close="onCancel"
    :close-on-click-modal="closeOnClickModal"
  >
    <template v-if="$slots.title" #title>
      <slot name="title"></slot>
    </template>
    <slot></slot>
    <template v-if="footerShow" #footer>
      <slot name="footer">
        <div>
          <el-button @click="onCancel" :loading="btnLoading">{{ cancelText }}</el-button>
          <el-button @click="onConfirm" type="primary" :loading="btnLoading">{{ confirmText }}</el-button>
        </div>
      </slot>
    </template>

    <!-- <template v-if="footerShow">
      <slot name="footer" v-if="$slots.footer"></slot>
      <div v-else slot="footer">
        <el-button @click="onCancel" :loading="btnLoading">{{ cancelText }}</el-button>
        <el-button @click="onConfirm" type="primary" :loading="btnLoading">{{ confirmText }}</el-button>
      </div>
    </template> -->
  </el-dialog>
</template>

<script>
export default {
  name: 'ShDialog',
  props: {
    footerShow: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    btnLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onConfirm() {
      this.$emit('confirm')
    },
    onCancel() {
      this.$emit('update:visible', false)
      this.$emit('update:btnLoading', false)
      this.$emit('cancel')
    }
  }
}
</script>
